module.exports = function() {
  return new Worker(__webpack_public_path__ + "506ed39ffeddf4d22ff9.worker.js");
};